import React, { useState, useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

import { gsap } from 'gsap'

import useRefs from 'hooks/useRefs'
import Tabs from './Tabs'
import Category from './Category'


import css from './styles.module.scss'

const FAQ = ({ categories }) => {
  const [active, setActive] = useState(0)
  const wrapperRef = useRef()
  const categoriesRefs = useRefs(categories.length)

  useIsomorphicLayoutEffect(() => {
    gsap.to(wrapperRef.current, {
      duration: 0.8,
      ease: 'elastic.out(0.25, 0.35)',
      xPercent: -100 * active,
    })
    const filteredCategoriesRefs = categoriesRefs.current
      .filter((_, i) => {
        return i !== active
      })
      .map((category) => category.current)

    gsap.set(filteredCategoriesRefs, { height: 0 })
    gsap.to(filteredCategoriesRefs, {
      duration: 0.4,
      opacity: 0,
    })
    gsap.set(categoriesRefs.current[active].current, { height: 'auto' })
    gsap.to(categoriesRefs.current[active].current, {
      duration: 0.4,
      opacity: 1,
    })
  }, [active])

  return (
    <div className={css.FAQ}>
      <Tabs categories={categories} onClick={setActive} active={active} />
      <div className={css.categories}>
        <div ref={wrapperRef} className={css.categoriesWrapper}>
          {categories.map((category, i) => (
            <Category
              key={`tab-${category.name}-${i}`}
              forwardRef={categoriesRefs.current[i]}
              {...category}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default FAQ
